import { connect } from 'react-redux';
import autobind from 'core-decorators/lib/autobind';

import fetchCurrentSiteUser from 'widget/redux/server/actions/current-site-user/get';
import updateAppSettings from 'widget/redux/client/actions/app-settings/update';

import { getInstanceFromPopup } from 'shared/utils/open-overlay';

import { getCurrentSiteUser } from 'widget/selectors/current-site-user';

import DataLoader from 'shared/data-components/_data-loader';


@connect(state => ({
  currentSiteUser: getCurrentSiteUser(state),
}), {
  fetchCurrentSiteUser,
  updateAppSettings,
})
export default class CurrentSiteUser extends DataLoader {

  static displayName = 'CurrentSiteUser';

  static propTypes = {
    currentSiteUser: React.PropTypes.object,
    fetchCurrentSiteUser: React.PropTypes.func,
    updateAppSettings: React.PropTypes.func,
  };

  state = {
    isFetching: false,
  };

  @autobind
  setFetchingState() {
    this.setState({
      isFetching: false,
    });
  }

  @autobind
  unsetFetchingState() {
    this.setState({
      isFetching: false,
    });
  }

  loadData() {
    this.setFetchingState();
    const loadingPromise = this.props.fetchCurrentSiteUser();
    loadingPromise.then(this.unsetFetchingState, this.unsetFetchingState);

    return loadingPromise;
  }

  @autobind
  fetchUser() {
    return getInstanceFromPopup()
      .then(instance => this.props.updateAppSettings({ instance }))
      .then(() => this.loadDataDebounced());
  }

  get childProps() {
    const { currentSiteUser } = this.props;
    const { isFetching } = this.state;

    return {
      currentSiteUser: {
        isFetching,
        data: currentSiteUser,
        fetch: this.fetchUser,
      },
    };
  }
}



// WEBPACK FOOTER //
// ./src/widget/data-components/current-site-user.js